// extracted by mini-css-extract-plugin
export var hideEditor = "_ht-2";
export var infoIcon = "_ht-3";
export var label = "_ht-1";
export var labelContainer = "_ht-0";
export var readonlyText = "_ht-4";